import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * Migration to move competency questions from project to diagram model data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v45 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v45Projects(prevState.projects);
  }

  return nextState;
};

const v45Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<
      string,
      Project & { competencyQuestions?: string[] }
    >
  ).forEach(([projectId, { competencyQuestions, diagram, ...project }]) => {
    const updatedDiagram = diagram.model?.modelData
      ? {
          ...diagram,
          model: {
            ...diagram.model,
            modelData: {
              ...diagram.model.modelData,
              competencyQuestions: competencyQuestions || [],
            },
          },
        }
      : diagram;

    projectsById[projectId] = {
      ...project,
      diagram: updatedDiagram as DiagramSnapshot,
    };
  });

  return { ...prevProjectsState, projectsById };
};
